type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  placeholder?: string;
  minLength?: number;
  maxLength?: number;
  error?: string;
};

export function TextArea({
  id,
  label,
  value,
  onChange,
  required,
  placeholder,
  minLength,
  maxLength,
  error,
}: Props) {
  return (
    <div>
      <label htmlFor={id} className="field-label">
        {label}
        {required && (
          <span className="req" aria-hidden="true">
            *
          </span>
        )}
      </label>
      {minLength && (
        <div className="field-help">A sentence or two is plenty — minimum {minLength} characters.</div>
      )}
      <textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        aria-required={required}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-error` : `${id}-counter`}
        className={error ? "input-error" : undefined}
      />
      {maxLength && (
        <div id={`${id}-counter`} className="field-counter" aria-live="polite">
          {value.length} / {maxLength}
        </div>
      )}
      {error && (
        <div id={`${id}-error`} className="field-error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}
